import React from "react";
import { t } from "../../utils/i18n";

const SuccessUpdatedModal = ({ action, store_id, integration,  }) => {

  const handleReload = () => {
    window.location.href = `/stores/${store_id}/integrations`;
  };  

  return (
    <div
      className="modal-delistoffers-alert-cont"
      aria-hidden="true"
      aria-labelledby="delistOffers"
    >
      <div>
        <h5 className="delistoffer-modal-title">
          <i className="fas fa-check-circle"></i>
          <span>{action === "Updated" ? t("store_integrations.success.updated") : t("store_integrations.success.action", { action })}</span>
        </h5>

        <div className="delistoffer-modal-buttons-section">
          <button
            type="button"
            className="delistoffer-modal-tradeaction-proceedbtn"
            onClick={handleReload}
          >
            {t("store_integrations.success.okay")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SuccessUpdatedModal;
